module.exports = __webpack_public_path__ + "img/icon_map_188_off_101.a5591f46.png";